
// Live server URL below
const environment = {
    BASE_URL: "https://azproxy.e.org",
    debug: true,
};


// Staging server URL below
// const environment = {
//     BASE_URL: "https://azproxyuat.e.org",
//     debug: true,
// };

export default environment;